import { NgbModal, NgbModalOptions, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { TemplateRef } from '@angular/core';

export class GenericBase {
  constructor(private modalService: NgbModal) {}

  public openModal(content: TemplateRef<any>, options: NgbModalOptions): NgbModalRef {
    return this.modalService.open(content, options);
  }
}
